<template>
  <ThePage :title="i18n(translations.title)">
    <template #pageTitle>
      {{ i18n(translations.title) }}
    </template>
    <template #pageContent>
      <NavTabs
        :index-route-name="ROUTE_NAMES.OPTIONS.INDEX"
        :label="translations.navigation"
        :should-show-label
      />
    </template>
  </ThePage>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { ROUTE_NAMES } from '~/constants/routes'
import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

import translations from './Options.translations'

const i18n = useI18n()
const { hasOnlyOneMarket, onboardingCompleted } = useSellerInfoStore()

function shouldShowLabel(routeName: string): boolean {
  const onboardingRoutesHidden = [ROUTE_NAMES.OPTIONS.BATCH_LISTING_CREATION]

  if (!onboardingCompleted && onboardingRoutesHidden.includes(routeName))
    return false

  const routesThatRequireMultipleMarkets = [ROUTE_NAMES.OPTIONS.PRICING]

  if (hasOnlyOneMarket && routesThatRequireMultipleMarkets.includes(routeName))
    return false

  return true
}
</script>
